module.exports = __webpack_public_path__ + "code-white.svg?2fd0ddf4f98c2414e790430fc04e81ac";